<cipo-dialog-header [title]="data.title || 'actions.addNew'" fullScreen="never" />
<mat-dialog-content>
    <div class="p-t">
        @if (data.description) {
            <p>{{ data.description | translate }}p></p>
        }
        <cipo-autocomplete [control]="control" [options]="data.options ?? ((data.getOptions | async) || [])" />
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-raised-button mat-dialog-close>{{ "actions.close" | translate }}</button>
    <button mat-raised-button color="primary" (click)="submitResult()">{{ "actions.save" | translate }}</button>
</mat-dialog-actions>
